import { Button, Typography } from '@breetometer/components';
import { classNameMerger } from '@breetometer/utils';
import { AngleRightNavIcon, LockIcon, TodoListTrackerIcon } from 'BreetAssets';
import { capitalizeFirstLetters } from 'BreetHelpers';

import type { IDialogOnboardingTodoListItem } from './DialogOnboardingTodoList.helpers';

const DialogOnboardingTodoListItem = ({
	header,
	status,
	subHeader,
	onClick,
	isLast,
	btnTitle,
	variant = 'timeline',
	locked,
	lockedHint,
	rejectionReason,
}: IDialogOnboardingTodoListItem) => {
	if (variant === 'card')
		return (
			<CardVariant
				header={header}
				onClick={onClick}
				subHeader={subHeader}
				locked={locked}
				lockedHint={lockedHint}
			/>
		);

	return (
		<div className={classNameMerger('todo-list-item', !!rejectionReason && 'has-rejection')}>
			<div className='todo-list-left'>
				<div className={classNameMerger('progress-tracker', status)}>
					<TodoListTrackerIcon
						status={status}
						className={classNameMerger('svg-dark svg-dark-outline', status === 'pending' && 'svg-dark-outline')}
					/>

					{!isLast && <div className={classNameMerger('progress-tracker-tail', status)} />}
				</div>

				<div className='todo-list-item-txt'>
					<div className='todo-list-item-heading'>
						<Typography
							as='h6'
							className={classNameMerger(status !== 'completed' ? 'color-neutral-50' : 'color-tertiary-400')}
						>
							{header}
						</Typography>
						{!!rejectionReason && <span className='todo-list-rejected-badge'>Rejected</span>}
					</div>
					<Typography className='color-primary-100'>{subHeader}</Typography>
				</div>
			</div>

			{locked ? (
				<span
					className='todo-list-item-lock'
					aria-label='Locked until KYB is approved'
				>
					<LockIcon />
				</span>
			) : (
				<Button
					className={classNameMerger(
						status === 'get-started' && 'tertiary-semi-hover',
						'todo-list-item-status',
						// 'theme-background-none',
						status
					)}
					onClick={status === 'get-started' ? onClick : undefined}
					variant='native'
				>
					{capitalizeFirstLetters(btnTitle ?? (status === 'get-started' ? 'get started' : status))}
				</Button>
			)}

			{!!rejectionReason && (
				<div className='todo-list-item-rejection'>
					<div className='content-child scrollbar'>
						<Typography
							as='span'
							className='todo-list-item-rejection-label'
						>
							Reason for rejection
						</Typography>
						<Typography
							as='p'
							className='scrollbar'
						>
							{rejectionReason}
						</Typography>
					</div>
				</div>
			)}
		</div>
	);
};

export default DialogOnboardingTodoListItem;

const CardVariant = ({
	lockedHint,
	locked,
	onClick,
	header,
	subHeader,
}: {
	lockedHint?: string;
	locked?: boolean;
	onClick?: () => void;
	header: string;
	subHeader: string;
}) => (
	<Button
		variant='native'
		className={classNameMerger('todo-list-item todo-list-item--card bg-primary-400', !!locked && 'locked')}
		onClick={locked ? undefined : onClick}
		disabled={!!locked}
	>
		<div className='todo-list-item-txt'>
			<Typography
				as='h6'
				className='color-primary-50'
			>
				{header}
			</Typography>
			<Typography className='color-primary-100'>{locked && lockedHint ? lockedHint : subHeader}</Typography>
		</div>

		{locked ? (
			<LockIcon className='todo-list-card-arrow svg-dark' />
		) : (
			<AngleRightNavIcon className='todo-list-card-arrow svg-dark' />
		)}
	</Button>
);
